import axios from "axios";
const endpoint = process.env.VUE_APP_BASE_API + "/api/maps";

export default {
  async getDistanceMatrix(query) {
    return await axios
      .get(endpoint + `/distance-matrix${query}`)
      .then(response => {
        return response.data.data;
      })
      .catch(error => {
        throw error.response.data;
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/maps/mapsService.js